import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {AuthenticationService} from '../../services/authentication.service';
import {ResidentService} from '../../services/resident.service';
import {MaintenanceCalendarService} from '../../services/maintenance-calendar.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'maintenance-calendar.component.html',
})
export class MaintenanceCalendarComponent implements OnInit, OnDestroy {
    residentBuildings: any = [];
    amenitiesData: any[] = [];

    constructor(public maintenanceCalendarService: MaintenanceCalendarService,
                public urlService: UrlService,
                public authenticationService: AuthenticationService,
                private residentService: ResidentService
    ) {
    }

    ngOnInit() {
        this.maintenanceCalendarService.view = 'calendar';
        this.urlService.setQueryParams('allAmenities');
        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => this.maintenanceCalendarService.tabId = this.urlService.queryParams['tab']
                ),
                flatMap(() => this.maintenanceCalendarService.getDataByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();

        if (this.authenticationService.userIsResident) {
            this.residentService.getBuildingsInfo()
                .then(() => this.maintenanceCalendarService.getAmenitiesList())
                .then(() => this.maintenanceCalendarService.getData());
        } else {
            this.maintenanceCalendarService.getAmenitiesList();
            this.maintenanceCalendarService.getBuildings();
        }

    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.maintenanceCalendarService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    onAmenitiesChange(event) {
        if (this.amenitiesData.indexOf(event) === -1) {
            this.amenitiesData.push(event);
        }
        this.amenitiesData.forEach((item, index) => {
            if (!item.checked) this.amenitiesData.splice(index, 1);
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.maintenanceCalendarService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar.component.ts